import React from 'react'

const UserRecoveryPage = ({ classes }) => {
  return (
    <div className={classes.pageContainer}>
      <div className={classes.loginWrapper}>
      </div>
    </div>
  )
}

export default UserRecoveryPage
